// AdminpanelData.js

/**
 * Official data for the Admin Panel team members.
 * 
 * @type {Array<Object>}
 */
const teamData = [
  {
    name: 'Machavarapu Mohan Durga Pradeep',
    image: '', // Add image URL if available
    rollNumber: '20VV1A1232',
    year: '2023-2024',
    role: '',
    website: '',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
  },
  {
    name: 'Manda Sai Sita Mahalaxmi',
    image: '',
    rollNumber: '20VV1A1234',
    year: '2023-2024',
    role: '',
    website: '',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
  },
  {
    name: 'Rangisetti Bindu Harshita',
    image: '',
    rollNumber: '20VV1A1254',
    year: '2023-2024',
    role: '',
    website: '',
    linkedin: '',
    github: '',
    instagram: '',
    email: '',
  },
  {
    name: 'Dannana Sai Ajith Kumar',
    image: '',
    rollNumber: '21VV5A1268',
    year: '2023-2024',
    role: 'Full Stack Developer',
    website: 'https://dsak.in/',
    linkedin: 'https://www.linkedin.com/in/saiajithkumardannana/',
    github: 'https://github.com/dannana-sai-ajith-kumar',
    instagram: 'https://www.instagram.com/dannana_sai_ajith_kumar/',
    email: 'mailto:dsak.official@gmail.com',
  },
  {
    name: 'Anil Sinthu',
    image: '',
    rollNumber: '22VV5A1273',
    year: '2024-2025',
    role: 'Full Stack Developer',
    website: 'https://anilsinthu.vercel.app/',
    linkedin: 'https://www.linkedin.com/in/anilsinthu',
    github: 'https://github.com/anilsinthu73',
    instagram: 'https://www.instagram.com/mr.anil_sinthu/',
    email: 'mailto:anilsinthu114@gmail.com',
  }
];

export default teamData;
